import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {sortBySortOrder} from '../../_utils/sortable-utils';
import {AlertController} from '@ionic/angular';
import {OrderItemService} from '../../_services/order-item.service';

@Component({
    selector: 'bb-order-modifier-selection',
    templateUrl: './order-modifier-selection.component.html',
    styleUrls: ['./order-modifier-selection.component.scss'],
})
export class OrderModifierSelectionComponent implements OnInit, OnChanges {
    @Input() selection: any;
    @Input() modifiers: any[];
    @Input() lines = 'none';
    @Input() child = false;
    @Output() modifiersChange = new EventEmitter<any[]>();

    selectedOption: any;
    options: any[];
    selectedOptions: any;
    openModal = false;
    selectionMessage: string;

    constructor(
        private orderItemService: OrderItemService,
        private alertController: AlertController
    ) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes && !!changes.modifiers) {
            if (!!this.selection && !!this.modifiers) {
                this.selectedOptions = this.selection.options
                    .filter(o => this.modifiers.some(m => m.menuModifier.id === o.menuModifier.id));
            }
        }
        this.setSelectionMessage();
    }

    ngOnInit(): void {
        this.options = this.sortOptions(this.selection.options);

        this.selectedOptions = this.selection.options
            .filter(o => this.modifiers.some(m => m.menuModifier.id === o.menuModifier.id));

        if (!this.selection.menuModifierSelection.required && this.selectedOptions.length === 0) {
            this.selectedOption = 'none';
        } else if (this.selectedOptions.length === 1) {
            this.selectedOption = this.selectedOptions[0];
        }
    }

    sortOptions(options: any[]) {
        options.forEach(o => {
            const option = this.selection.menuModifierSelection.options.find(m => m.menuModifier.id === o.menuModifier.id);
            if (!!option) {
                o.sortOrder = option.sortOrder;
            }
        });

        return sortBySortOrder(options);
    }

    selectionChange() {
        if (this.selectedOption === 'none') {
            this.modifiersChange.emit(this.modifiers.filter(m => !this.options.some(o => o.menuModifier.id === m.menuModifier.id)));
        } else {
            const modifiers = this.modifiers.filter(m => !this.options.some(o => o.menuModifier.id === m.menuModifier.id));

            modifiers.push(this.orderItemService.buildModifier(this.selection, this.selectedOption));
            this.modifiersChange.emit(modifiers);
        }
    }

    multiSelectionChange(selected: any) {
        if (!this.modifiers.some(m => selected.menuModifier.id === m.menuModifier.id)) {
            if (!!this.selection.menuModifierSelection.maxCount &&
                this.selectedOptions.length >= this.selection.menuModifierSelection.maxCount) {
                this.maxCountAlert();
            } else {
                const modifiers = this.selection.menuModifierSelection.maxCount === 1 ? [] : [...this.modifiers];
                modifiers.push(this.orderItemService.buildModifier(this.selection, selected));
                this.modifiersChange.emit(modifiers);
            }
        } else {
            this.modifiersChange.emit(this.modifiers.filter(m => selected.menuModifier.id !== m.menuModifier.id));
        }
    }

    setSelectionMessage() {
        let message = this.selection.menuModifierSelection.required ? 'Required' : 'Optional';
        if (this.selection.minCount > 0 && this.selection.menuModifierSelection.maxCount > this.selection.menuModifierSelection.minCount) {
            message += `, select ${this.selection.menuModifierSelection.minCount} to ${this.selection.menuModifierSelection.maxCount} options.`;
        } else if (this.selection.menuModifierSelection.minCount > 0
            && this.selection.menuModifierSelection.maxCount === this.selection.menuModifierSelection.minCount) {
            message += `, select ${this.selection.menuModifierSelection.minCount} option${this.selection.menuModifierSelection.minCount > 1
                ? 's'
                : ''}.`;
        } else if (this.selection.menuModifierSelection.minCount > 0 && this.selection.menuModifierSelection.maxCount == null) {
            message += `, select at least ${this.selection.menuModifierSelection.minCount} options.`;
        } else if ((this.selection.menuModifierSelection.minCount == null || this.selection.menuModifierSelection.minCount === 0)
            && this.selection.menuModifierSelection.maxCount > 0) {
            message += `, select up to ${this.selection.menuModifierSelection.maxCount} options.`;
        }
        this.selectionMessage = message;
    }

    async maxCountAlert() {
        const alert = await this.alertController.create({
            cssClass: 'brewbill-alert',
            header: 'Max Selections',
            message: 'You have added the maximum number of modifiers for this selection. '
                + 'Please remove an item before adding anything new.',
            buttons: [
                {
                    text: 'Close',
                    role: 'cancel',
                    cssClass: 'secondary',
                }
            ]
        });

        await alert.present();
    }
}
